import CardToken from '@apps/finance/admin/tokens/card'
import Details from '@admin/components/details'
import Panel from '@admin/components/panel'
import PropTypes from 'prop-types'
import pluralize from 'pluralize'
import numeral from 'numeral'
import React from 'react'

const Overview = ({ agency, signup }) => {

  const details = {
    comments: `maha_signups/${signup.id}`,
    sections: [
      {
        title: 't(Signup Details)',
        items: [
          { label: 't(Signup Page)', content: signup.signup_page ? signup.signup_page.title : null },
          { label: 't(Signed Up At)', content: signup.created_at, format: 'datetime' },
          ...signup.configured_at ? [
            { label: 't(Configured At)', content: signup.configured_at, format: 'datetime' }
          ] : []
        ]
      },
      {
        title: 't(Signup Data)',
        items: [
          { label: 't(First Name)', content: signup.data.first_name },
          { label: 't(Last Name)', content: signup.data.last_name },
          { label: 't(Business Name)', content: signup.data.organization },
          { label: 't(Email)', content: signup.data.email },
          { label: 't(Referred By)', content: signup.data.referred_by },
          { label: 't(Agreed to Terms)', content: signup.data.agreed_to_terms, format: 'yes_no' },
          { label: 't(Email Consent)', content: signup.data.email_consent, format: 'yes_no' },
          { label: 't(Plan)', content: signup.plan ? `${signup.plan.title} (${numeral(signup.plan.price).format('0.00')})` : null },
          { label: 't(Setup Fee)', content: signup.data.setup_fee, format: 'currency' },
          { label: 't(Free Setup)', content: signup.data.free_setup, format: 'yes_no' },
          { label: 't(Trial Length)', content: signup.data.trial_length ? pluralize('month', signup.data.trial_length, true) : null },
          { label: 't(Payment Method)', padded: false, content: signup.payment_method ? <CardToken payment_method={ signup.payment_method } /> : null }
        ]
      }
    ]
  }

  return <Details { ...details } />

}

Overview.propTypes = {
  agency: PropTypes.object,
  signup: PropTypes.object
}

const mapPropsToPanel = (props, context) => ({
  title: 't(Overview)',
  panel: <Overview agency={ props.agency } signup={ props.signup } />
})

const mapResourcesToPanel = (props, context) => ({
  signup: `/api/admin/truevail/admin/agencies/${props.agency.id}/signup`
})

export default Panel(mapResourcesToPanel, mapPropsToPanel)